import { useState } from "react";
import { Sunrise } from "lucide-react";
import { MomentShell, SaveButton, EditLink } from "./MomentShell";
import { Chips, Field, WHEN, inputCls } from "./Chips";

export function MorningStep({ data, day, options, plan, time, onSave }) {
  const [editing, setEditing] = useState(!plan);
  const [goal, setGoal] = useState(plan?.goal || "");
  const [choice, setChoice] = useState(plan ? (plan.option ?? "custom") : (options.length ? 0 : "custom"));
  const [custom, setCustom] = useState(plan && plan.option == null ? plan.action : "");
  const [minimal, setMinimal] = useState(plan ? plan.minimal || "" : options[0]?.minima || "");
  const [touched, setTouched] = useState(!!plan);
  const [when, setWhen] = useState(plan?.when || null);
  const [saving, setSaving] = useState(false);

  const action = choice === "custom" ? custom.trim() : options[choice]?.testo;
  const pick = (i) => { setChoice(i); if (!touched) setMinimal(i === "custom" ? "" : options[i]?.minima || ""); };

  const save = async () => {
    setSaving(true);
    const ok = await onSave({ action, option: choice === "custom" ? null : choice, minimal: minimal.trim(), when: when || "", ...(day === 1 ? { goal: goal.trim() } : {}) });
    setSaving(false);
    if (ok) setEditing(false);
  };

  return (
    <MomentShell icon={Sunrise} label="Mattino" time={time} title={data?.titolo || "Scegli il tuo passo"} text={data?.app} done={!!plan} index={0} testid="moment-mattino">
      {!editing && plan ? (
        <div className="mt-4 rounded-xl border border-[#27272A] bg-[#0D0D0F] p-4" data-testid="morning-plan-summary">
          <p className="text-[12px] font-semibold uppercase tracking-wider text-[#D4AF37]">Il tuo passo di oggi</p>
          <p className="a2g-read mt-1 text-base font-medium text-[#F4F4F5]">{plan.action}</p>
          {plan.goal && <p className="mt-2 text-sm text-[#B4B4BC]" data-testid="morning-goal-summary">Obiettivo della settimana: {plan.goal}</p>}
          {plan.minimal && <p className="mt-2 text-sm text-[#B4B4BC]">{plan.reduced ? "Versione ridotta in uso" : "Versione minima"}: {plan.minimal}</p>}
          {plan.when && <p className="mt-1 text-sm text-[#B4B4BC]">Quando: {plan.when}</p>}
          <EditLink onClick={() => setEditing(true)} testid="morning-edit-button" />
        </div>
      ) : (
        <>
          {day === 1 && (
            <Field label="Il tuo obiettivo per questa settimana">
              <input value={goal} onChange={(e) => setGoal(e.target.value)} maxLength={200} placeholder="In una riga: su cosa vuoi lavorare?" className={inputCls} data-testid="morning-goal-input" />
            </Field>
          )}
          <Field label="Scegli il tuo passo">
            <div className="mt-2 space-y-2">
              {options.map((o, i) => (
                <OptionButton key={i} active={choice === i} onClick={() => pick(i)} testid={`morning-option-${i}`}>{o.testo}</OptionButton>
              ))}
              <OptionButton active={choice === "custom"} onClick={() => pick("custom")} testid="morning-option-custom">La adatto io</OptionButton>
            </div>
            {choice === "custom" && (
              <input value={custom} onChange={(e) => setCustom(e.target.value)} maxLength={200} placeholder="Scrivi il tuo passo in una riga" className={inputCls} data-testid="morning-custom-input" />
            )}
          </Field>
          <Field label="Versione minima (se la giornata si complica)">
            <input value={minimal} onChange={(e) => { setMinimal(e.target.value); setTouched(true); }} maxLength={200} placeholder="Es. 5 minuti invece di 20" className={inputCls} data-testid="morning-minimal-input" />
          </Field>
          <Field label="Quando la fai?">
            <Chips options={WHEN} value={when} onChange={setWhen} testid="morning-when" />
          </Field>
          <SaveButton onClick={save} disabled={!action || action.length < 2} saving={saving} label="Salva il mio passo" testid="morning-save-button" />
        </>
      )}
    </MomentShell>
  );
}

function OptionButton({ active, onClick, children, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`a2g-read w-full rounded-xl border p-3.5 text-left text-base transition-colors ${active ? "border-[#D4AF37] bg-[#D4AF37]/10 text-[#F4F4F5]" : "border-[#27272A] bg-[#0D0D0F] text-[#B4B4BC] hover:border-[#3F3F46]"}`}
    >
      {children}
    </button>
  );
}
